import React from 'react';
import Container from '../../../containers/integration/modules/editModuleContainer';

export default function () {
  return (
    <Container />
  );
}
